<script setup>

import {useRoute, useRouter} from "vue-router";
import {storeToRefs} from "pinia/dist/pinia";
import {useUserGoalStore} from "@/stores/userGoal.store";
import {onMounted} from "vue";


const route = useRoute();
const router = useRouter();
const userGoalStore = useUserGoalStore();
const {userGoal, goalCategories} = storeToRefs(userGoalStore);

onMounted(async () => {
    await userGoalStore.fetchCategories();
    if (route.params.id > 0) {
        await userGoalStore.fetchOne(route.params.id);
    } else {
        userGoalStore.reset();
    }
});

const doSubmit = async () => {
    if (route.params.id === '0') {
        await userGoalStore.createOne().then(() => {
            router.push('/goal/' + userGoal.value.id);
        });
    } else {
        await userGoalStore.updateOne(route.params.id);
    }
};

</script>

<template>
    <van-form @submit="doSubmit">
        <van-cell-group inset>
            <van-field
                v-model="userGoal.name"
                size="large"
                required
                placeholder="Goal"
                :rules="[{ required: true, message: 'Please input your goal' }]"
            />
            <van-field
                v-model="userGoal.description"
                placeholder="Description"
                size="large"
                :rules="[{ required: true, message: 'Please input description' }]"
            />
            <van-field
                v-model="userGoal.start_at_formatted"
                placeholder="Start: YYYY-MM-DD"
                size="large"
                required
                :rules="[{ required: true, message: 'Please input start at date' }]"
            />
            <van-field
                v-model="userGoal.complete_at_formatted"
                placeholder="Complete: YYYY-MM-DD"
                size="large"
                required
                :rules="[{ required: true, message: 'Please input complete at date' }]"
            />
        </van-cell-group>

        <van-divider/>

        <van-cell-group inset>
            <van-cell>
                <template #title>
                    <b>Category</b>
                </template>
            </van-cell>
            <van-radio-group v-model="userGoal.goal_category_id">
                <van-cell-group v-for="goalCategory in goalCategories" :key="goalCategory.id">
                    <van-cell :title="goalCategory.name" clickable>
                        <template #right-icon>
                            <van-radio :name="goalCategory.id" :label="goalCategory.name"/>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-cell-group>


        <van-divider/>

        <van-cell-group inset>
            <van-cell>
                <template #title>
                    <b>Status</b>
                </template>
            </van-cell>
            <van-radio-group v-model="userGoal.status">
                <van-cell-group>
                    <van-cell title="Pending" clickable @click="userGoal.status = 'Pending'">
                        <template #right-icon>
                            <van-radio name="Pending"/>
                        </template>
                    </van-cell>
                </van-cell-group>
                <van-cell-group>
                    <van-cell title="In Progress" clickable @click="userGoal.status = 'In_Progress'">
                        <template #right-icon>
                            <van-radio name="In_Progress"/>
                        </template>
                    </van-cell>
                </van-cell-group>
                <van-cell-group>
                    <van-cell title="Completed" clickable @click="userGoal.status = 'Completed'">
                        <template #right-icon>
                            <van-radio name="Completed"/>
                        </template>
                    </van-cell>
                </van-cell-group>
                <van-cell-group>
                    <van-cell title="Overdue" clickable @click="userGoal.status = 'Overdue'">
                        <template #right-icon>
                            <van-radio name="Overdue"/>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-cell-group>

        <van-divider/>

        <van-cell-group inset>
            <van-cell>
                <template #title>
                    <b>My Progress</b>
                </template>
                <template #value>
                    <van-button type="primary" size="mini" @click="userGoal.progresses.push('')">Add</van-button>
                </template>
            </van-cell>
            <span v-for="(progress, index) in userGoal.progresses" :key="index">
                <van-cell-group>
                    <van-field
                        v-model="userGoal.progresses[index]"
                        placeholder="Input your progress"
                        size="large"
                        :rules="[{ required: true, message: 'Please input progress' }]"
                    >
                        <template #button>
                            <van-button
                                type="danger"
                                size="mini"
                                icon="delete"
                                @click="userGoal.progresses.splice(index, 1);"
                            />
                        </template>
                    </van-field>
                </van-cell-group>
            </span>
        </van-cell-group>

        <van-divider/>

        <van-cell-group inset>
            <van-button v-if="route.params.id === '0'" block round type="success" native-type="submit">
                Create
            </van-button>
            <van-button v-else block round type="success" native-type="submit">
                Update
            </van-button>
        </van-cell-group>


    </van-form>
</template>
